import {
  IMGCLUB,
  IMG_YOUTH_GATHERING_PLACE,
  IMG_CAFE,
  IMG_TTTM,
  IMG_UNIVERSITY,
  IMG_K_BOX,
  IMG_SCREEN_STEP1,
  IMG_SCREEN_STEP2,
  IMG_SCREEN_STEP3,
  IMG_SCREEN_STEP4,
  IMG_SCREEN_STEP5,
  IMG_SCREEN_STEP6,
} from "./imagesUrl";
import CameraIcon from "@/components/atoms/icons/CameraIcon";
import VideoIcon from "@/components/atoms/icons/VideoIcon";
import DesignIcon from "@/components/atoms/icons/DesginIcon";
import SupportIcon from "@/components/atoms/icons/SupportIcon";
import QRIcon from "@/components/atoms/icons/QRIcon";
import DevicesIcon from "@/components/atoms/icons/DevicesIcon";
import TrainningIcon from "@/components/atoms/icons/TrainningIcon";
import HandCoinIcon from "@/components/atoms/icons/HandCoinIcon";
import { TFunction } from "i18next";
import { Feature, UserInterfaceImage } from "./types";

export const infoSuggestCards = (t: TFunction) => [
  {
    heading: t("home.suggest_cards.club_bars.heading"),
    imageSrc: IMGCLUB,
    alternText: "club/bars",
    description: t("home.suggest_cards.club_bars.description"),
  },
  {
    heading: t("home.suggest_cards.youth_gathering.heading"),
    imageSrc: IMG_YOUTH_GATHERING_PLACE,
    alternText: "Tourist attractions",
    description: t("home.suggest_cards.youth_gathering.description"),
  },
  {
    heading: t("home.suggest_cards.university.heading"),
    imageSrc: IMG_UNIVERSITY,
    alternText: "university",
    description: t("home.suggest_cards.university.description"),
  },
  {
    heading: t("home.suggest_cards.k_box.heading"),
    imageSrc: IMG_K_BOX,
    alternText: "Gen-Z businesses",
    description: t("home.suggest_cards.k_box.description"),
  },
  {
    heading: t("home.suggest_cards.cafe.heading"),
    imageSrc: IMG_CAFE,
    alternText: "campus-place",
    description: t("home.suggest_cards.cafe.description"),
  },
  {
    heading: t("home.suggest_cards.shopping_mall.heading"),
    imageSrc: IMG_TTTM,
    alternText: "shopping-mall",
    description: t("home.suggest_cards.shopping_mall.description"),
  },
];

export const featureSboxVn = (t: TFunction): Feature[] => [
  {
    heading: t("home.features.best_photo_quality"),
    icon: CameraIcon,
    description: t("home.features.best_photo_quality_description", { returnObjects: true }) as string[],
  },
  {
    heading: t("home.features.flexible_payment"),
    icon: QRIcon,
    description: t("home.features.flexible_payment_description", { returnObjects: true }) as string[],
  },
  {
    heading: t("home.features.digital_photo_video"),
    icon: VideoIcon,
    description: t("home.features.digital_photo_video_description", { returnObjects: true }) as string[],
  },
  {
    heading: t("home.features.all_in_one_solution"),
    icon: DevicesIcon,
    description: t("home.features.all_in_one_solution_description", { returnObjects: true }) as string[],
  },
  {
    heading: t("home.features.store_layout_consultation"),
    icon: DesignIcon,
    description: t("home.features.store_layout_consultation_description", { returnObjects: true }) as string[],
  },
  {
    heading: t("home.features.free_training_marketing_strategy"),
    icon: TrainningIcon,
    description: t("home.features.free_training_marketing_strategy_description", { returnObjects: true }) as string[],
  },
  {
    heading: t("home.features.competitive_investment_fee"),
    icon: HandCoinIcon,
    description: t("home.features.competitive_investment_fee_description", { returnObjects: true }) as string[],
  },
  {
    heading: t("home.features.technical_support_24_7"),
    icon: SupportIcon,
    description: t("home.features.technical_support_24_7_description", { returnObjects: true }) as string[],
  },
];

export const listImagesUserInterFace = (t: TFunction): UserInterfaceImage[] => [
  {
    imageSrc: IMG_SCREEN_STEP1,
    altText: "man-hinh-chinh",
    name: t("home.user_interface_steps.step1"),
  },
  {
    imageSrc: IMG_SCREEN_STEP2,
    altText: "Chọn-chu-de",
    name: t("home.user_interface_steps.step2"),
  },
  {
    imageSrc: IMG_SCREEN_STEP3,
    altText: "chon-co-anh",
    name: t("home.user_interface_steps.step3"),
  },
  {
    imageSrc: IMG_SCREEN_STEP4,
    altText: "thanh-toan",
    name: t("home.user_interface_steps.step4"),
  },
  {
    imageSrc: IMG_SCREEN_STEP5,
    altText: "take-photo",
    name: t("home.user_interface_steps.step5"),
  },
  {
    imageSrc: IMG_SCREEN_STEP6,
    altText: "xac-nhan-anh",
    name: t("home.user_interface_steps.step6"),
  },
];

export const LOGO_URL = "/images/img_logo.webp";
export const IMG_STANDARD_ANGLE = "/images/standard_angle.webp";
export const IMG_WHITE_STANDARD_ANGLE = "/images/white_standard_angle.webp";

export const IMG_MACHINR_DOUBLE = {
  machine1: "/images/machineOptions/machine_double1.webp",
  machine2: "/images/machineOptions/machine_double2.webp",
};
export const IMG_MACHINR_DULUXE = {
  machine1: "/images/machineOptions/duluxe_1.webp",
  machine2: "/images/machineOptions/duluxe_2.webp",
  machine3: "/images/machineOptions/duluxe_3.webp",
};
export const IMG_MACHINR_SNAP4U = {
  machine1: "/images/machineOptions/snap4U_1.webp",
  machine2: "/images/machineOptions/snap4U_2.webp",
};
export const IMG_MACHINR_SNAP_MOBILE = 
 "/images/machineOptions/snap_mobile_1.webp";
export const IMG_SELFBOOTH_SMART = "/images/machineOptions/selfbooth_smart.webp";

export const IMG_AI_PHOTOBOOTH = "/images/machineOptions/ai_photo_booth.webp";
export const IMG_TWO_VIEW_PHOTOBOOTH = "/images/machineOptions/two_view.webp";
export const IMG_ALEVATOR_ANGLE = "/images/elevator_angle.webp";
export const IMG_FLUFFE_STUDIO = "/images/FluffeStudio_Photo_Strip.webp";
export const IMG_HIGH_ANGLE = "/images/high_angle.webp";
export const IMG_HIGH_ANGLE_STUDIO = "/images/high_angle_studio.webp";
export const IMG_LOW_ANGLE = "/images/low_angle_photobooth.webp";
export const IMG_LOW_ANGLE_STUDIO = "/images/low_angle_studio.webp";
export const IMG_LOCATION = "/images/location.svg";

export const MIDDLE_FONT_SIZE = 16;
export const VIDEO_PHOTOBOOTH_HOT =
  "https://www.youtube.com/embed/1rvZv2lYKj0?autoplay=1&loop=1&playlist=1rvZv2lYKj0&rel=0&mute=1";

export const phoneRegex = /^(0|\+84)[3-9]\d{8}$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

